import makeStyles from '@mui/styles/makeStyles';

import { Theme } from '../types';

const rowFieldsStyles = makeStyles((theme: Theme) => ({
    minWidth160px: {
        minWidth: '160px'
    },
    width160px: {
        width: '160px'
    },
    minWidth30: {
        minWidth: theme.spacing(30)
    },
    flexGrow: {
        flexGrow: 1
    },
    padding0_1: {
        padding: theme.spacing(0, 1)
    },
    padding2px: {
        padding: '2px'
    },
    paddingLeft1: {
        paddingLeft: theme.spacing(1)
    },
    paddingBottom1: {
        paddingBottom: theme.spacing(1)
    }
}));

export default rowFieldsStyles;
